import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/Home.css';
import logo from '../styles/logo.png'; // Ensure this file exists

function Products() {
  return (
    <div className="container">
      <div className="content">
        <h2>Our Products</h2>
        <div className="products">
                <div className="product1">
                  <h3>TN Tender</h3>
                  <p>Subscribe to daily WhatsApp updates</p>
                  <Link to="/tenderform" className="btn btn-primary">Subscribe</Link>
                </div>
                <div className="product2">
                  <h3>TN Auction</h3>
                  <p>Subscribe to daily WhatsApp updates</p>
                  <Link to="/auctionform" className="btn btn-primary">Subscribe</Link>
                </div>
                <div className="product3">
                  <h3>Cake Design</h3>
                  <p>Follow the link to login to our page</p>
                  <Link to="/cakeapp" className="btn btn-primary">Click</Link>
                </div>
        </div>
      </div>
    </div>
  );
}

export default Products;